import React, { useRef, useState } from 'react';
import Badge from 'react-bootstrap/Badge';
import Spinner from 'react-bootstrap/Spinner';
import OverlayTrigger from 'react-bootstrap/OverlayTrigger';
import BSTooltip from 'react-bootstrap/Tooltip';
import { FaUser } from 'react-icons/fa';

export const formatDate = (dateStr) => {
    if (!dateStr) return '—';
    return new Date(dateStr).toLocaleDateString('en-GB', { day: 'numeric', month: 'short', year: 'numeric' });
};

export const formatRelative = (dateStr) => {
    if (!dateStr) return '—';
    const diff = Date.now() - new Date(dateStr).getTime();
    const days = Math.floor(diff / 86400000);
    if (days === 0) return 'Today';
    if (days === 1) return 'Yesterday';
    if (days < 30) return `${days} days ago`;
    const months = Math.floor(days / 30);
    return `${months} month${months > 1 ? 's' : ''} ago`;
};

let _tipId = 0;
export const InfoTip = ({ text }) => {
    const id = useRef(`tip-${++_tipId}`).current;
    return (
        <OverlayTrigger placement="top" overlay={<BSTooltip id={id}>{text}</BSTooltip>}>
            <span
                className="ms-1 text-muted"
                style={{ cursor: 'help', fontSize: '0.78em', verticalAlign: 'middle' }}
                aria-label="More information"
            >
                ⓘ
            </span>
        </OverlayTrigger>
    );
};

export const Th = ({ children, tip, className }) => (
    <th className={className}>
        {children}
        {tip && <InfoTip text={tip} />}
    </th>
);

export const AlignmentBadge = ({ value }) => {
    const variants = { Strong: 'success', Partial: 'warning', Divergent: 'danger' };
    return <Badge bg={variants[value] || 'secondary'}>{value || '—'}</Badge>;
};

export const EmptyRow = ({ cols, message = 'No data yet' }) => (
    <tr><td colSpan={cols} className="text-center text-muted py-3">{message}</td></tr>
);

export const Avatar = ({ guid }) => {
    const [errored, setErrored] = useState(false);
    if (errored) {
        return (
            <div style={{
                width: 28, height: 28, borderRadius: '50%',
                background: '#e9ecef', display: 'flex',
                alignItems: 'center', justifyContent: 'center', flexShrink: 0,
            }}>
                <FaUser style={{ fontSize: 11, color: '#adb5bd' }} />
            </div>
        );
    }
    return (
        <img
            src={`${process.env.REACT_APP_API_URL}/storage/avatars/${guid}.png`}
            alt=""
            onError={() => setErrored(true)}
            style={{ width: 28, height: 28, borderRadius: '50%', objectFit: 'cover', flexShrink: 0 }}
        />
    );
};

export const TabSpinner = () => (
    <div className="d-flex align-items-center justify-content-center py-5 text-muted">
        <Spinner animation="border" size="sm" className="me-2" />
        <span className="small">Loading…</span>
    </div>
);
